import { gql } from "@apollo/client";

// Components
import Head from "next/head";
import Header from "@/components-layout/header/header";
import Footer from "@/components-layout/footer/footer";
import Modules from "@/components-modules/modules/modules";
import PostContent from "@/components/post-content/postContent";

// Constants
import { genSetVars } from "@/constants/gql-fields";

export default function Component(props) {
  // Loading state for previews
  if (props.loading) {
    return <>Loading...</>;
  }

  // Variables
  const data = props.data;
  // const siteTitle = data.generalSettings.title;
  // const { title, id, content, modules } = data.page;
  const { id, content, modules } = data.page;

  return (
    <>
      <Head>
        {/* <title>{`${title} - ${siteTitle}`}</title> */}
        <title>{data.page.seo.title}</title>
        <meta name="description" content={data.page.seo.metaDesc} />
      </Head>

      <Header entry={data.generalSettingsOptionsPage.generalSettingsACF} />

      <main>
        {content && <PostContent content={content} />}
        {modules?.module && <Modules id={id} modules={modules.module} />}
      </main>

      <Footer entry={data.generalSettingsOptionsPage.generalSettingsACF} />
    </>
  );
}

Component.variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    // navID: "3" ,
    asPreview: ctx?.asPreview,
  };
};

Component.query = gql`
  query GetPage(
    $databaseId: ID!
    # $navID: ID = "3"
    $asPreview: Boolean = false
  ) {
    # -- Site Settings
    # generalSettings {
    #   title
    # }

    # -- Header Fragment
    ...HeaderFragment @unmask(mode: "migrate")

    # -- Footer Fragment
    ...FooterFragment @unmask(mode: "migrate")
    
    # -- Page Data
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      # title
      id
      __typename
      content
      ...ModulesFragment @unmask(mode: "migrate")

      seo {
        metaDesc
        # fullHead
        title
      }
    }

    # -- General Settings Variables
    ${genSetVars}
  }
  ${Header.fragments.entry}
  ${Modules.fragments.data}
  ${Footer.fragments.entry}
`;
